if (!customElements.get('swiper-component')) {
  const swiperJS = document.createElement("script");
  swiperJS.src = "//the-million-roses.myshopify.com/cdn/shop/t/293/assets/swiper-bundle.min.js?v=76204931248172345031734454349";
  swiperJS.defer = true;

  const swiperCSS = document.createElement("link");
  swiperCSS.href = "//the-million-roses.myshopify.com/cdn/shop/t/293/assets/swiper-bundle.min.css?v=57467293291238189081734454350";
  swiperCSS.rel = "stylesheet";
  swiperCSS.type = "text/css";

  document.body.appendChild(swiperCSS);
  document.body.appendChild(swiperJS);
  swiperJS.addEventListener("load", function () {
    document.querySelectorAll("swiper-component").forEach(function (swiperElement) { if(!swiperElement.swiper) swiperElement.initSwiper() });
  }, { once: true });

  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  customElements.define('swiper-component', class SwiperComponent extends HTMLElement {
    constructor() {
      super();
      if(this.hasAttribute("section-id")){
        this.section_id = this.getAttribute("section-id");
      }else if(this.closest("[id^='shopify-section-']")){
        this.section_id = this.closest("[id^='shopify-section-']").id?.split("shopify-section-")[1];
      }

      if(this.hasAttribute("breakpoints")){
        this.breakpoints = this.getAttribute("breakpoints").split("|").map(function (breakpoint) { return breakpoint.split("-") });
      }else{
        this.breakpoints = [[0, 'noswiper'], [750, 'noswiper']];
      }
    }

    connectedCallback() {
      this.settings = {
        on: {
          init: debounce(function (swiper) {
            if (!swiper.enabled) swiper.hostEl.classList.add('swiper-disabled');
            else swiper.hostEl.classList.remove('swiper-disabled');
          }, 500),
          resize: debounce(function (swiper) {
            if (!swiper.enabled) swiper.hostEl.classList.add('swiper-disabled');
            else swiper.hostEl.classList.remove('swiper-disabled');
          }, 500),
          breakpoint: debounce(function (swiper, breakpointParams) {
            if (!swiper.enabled && breakpointParams.enabled) swiper.init();
            else if (swiper.enabled && !breakpointParams.enabled) swiper.destroy(true, true);
          }, 500)
        }
      };

      this.parsed_attributes = Object.values(this.attributes).filter(function (attribute) { return attribute.name.includes("swiper-") }).map(function (attribute) {
        attribute.swiper_name = attribute.name.split("swiper-")[1].replace(/(-\w)/g, function (m) { return m[1].toUpperCase() });
        if (attribute.value.includes("|")) return attribute;
        if (isNaN(attribute.value)) {
          if (attribute.swiper_name.includes("Json")) this.settings[attribute.swiper_name.replace('Json', '')] = JSON.parse(attribute.value.replaceAll("'", '"'));
          else if (/^(true|false)$/i.test(attribute.value)) this.settings[attribute.swiper_name] = attribute.value === "true";
          else this.settings[attribute.swiper_name] = attribute.value;
        } else this.settings[attribute.swiper_name] = Number(attribute.value);
      }.bind(this)).filter(function (attribute) { return !!attribute })

      this.settings.breakpoints = Object.assign({}, ...this.breakpoints.map(function (breakpoint, index) {
        let breakpointSetting = {}
        if (breakpoint[1] == 'swiper') breakpointSetting = Object.assign({enabled: true}, ...this.parsed_attributes.map(function (attribute) {
          if (isNaN(attribute.value.split("|")[index])) {
            if (attribute.swiper_name.includes("Json")) return { [attribute.swiper_name.replace('Json', '')]: JSON.parse(attribute.value.split("|")[index]) };
            else if (/^(true|false)$/i.test(attribute.value.split("|")[index])) return { [attribute.swiper_name]: attribute.value.split("|")[index] === "true" };
            else return { [attribute.swiper_name]: attribute.value.split("|")[index] };
          } else return { [attribute.swiper_name]: Number(attribute.value.split("|")[index]) };
        })); else breakpointSetting.enabled = false;

        return { [Number(breakpoint[0])]: breakpointSetting }
      }.bind(this)));

      if(this.hasAttribute('shuffle') && this.getAttribute('shuffle') === 'true'){
        const swiperWrapper = this.querySelector('.swiper-wrapper');
        const slides = Array.from(swiperWrapper.children);
        const shuffledSlides = this.shuffle(slides);
        shuffledSlides.forEach(slide => swiperWrapper.appendChild(slide));
      }

      if ('Swiper' in window || ('Swiper' in window && window.designMode)) this.initSwiper()
    }

    initSwiper() {
      this.swiper = new Swiper(this, this.settings);
      this.swiper.on('slideChange', function () {
        this.dispatchEvent(new CustomEvent('slideChange', { detail: { swiper: this.swiper } }));
      }.bind(this));
    }

    shuffle(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }

      return array;
    }
  })
}
